import { RunIdentificationPair } from '@neptune/shared/entity-domain';

export function filterIdentificationPairsToRemove(params: {
  identificationPairsToRemove: RunIdentificationPair[];
  runIds: string[];
  experimentNames: string[];
  runIdToExperimentName?: Record<string, string>;
  allowedToRemovePair?: boolean;
}) {
  const {
    runIds,
    experimentNames,
    identificationPairsToRemove,
    runIdToExperimentName,
    allowedToRemovePair = false,
  } = params;
  const runIdsToRemove = new Set<string>();
  const experimentNamesToRemove = new Set<string>();

  if (runIdToExperimentName) {
    for (const pair of identificationPairsToRemove) {
      if (runIdToExperimentName[pair.runId]) {
        experimentNamesToRemove.add(runIdToExperimentName[pair.runId]);
      }
    }
  }

  for (const pair of identificationPairsToRemove) {
    const resolvedExperimentName = pair.experimentName ?? runIdToExperimentName?.[pair.runId];

    if (resolvedExperimentName) {
      // if experiment name is defined, it takes priority
      experimentNamesToRemove.add(resolvedExperimentName);

      if (allowedToRemovePair) {
        // if allowed to remove pair, remove the run id as well
        runIdsToRemove.add(pair.runId);
      }
    } else {
      runIdsToRemove.add(pair.runId);
    }
  }

  const runIdsFiltered = runIds.filter((id) => !runIdsToRemove.has(id));
  const experimentNamesFiltered = experimentNames.filter(
    (name) => !experimentNamesToRemove.has(name),
  );

  return {
    runIdsFiltered,
    experimentNamesFiltered,
    runIdsToRemove: [...runIdsToRemove],
    experimentNamesToRemove: [...experimentNamesToRemove],
  };
}
